import styled from "styled-components";

const Sub = styled.div`
  display: flex;
  justify-content: center;
  font-size: 1.6rem;
`;

export default Sub;
